// extracted by mini-css-extract-plugin
export default {"priceNote":"AddInflatedPriceModal_priceNote__MRkql","price":"AddInflatedPriceModal_price__SK9Qo"};